import {
  ACCOUNT_ACTIVE,
  ACCOUNT_LOGIN,
  ACCOUNT_REGISTER,
  ADD_COMMENT,
  ADD_NEW_ADDRESS,
  ADD_TO_CART,
  CALLBACK_PAYMENT,
  CONTACT_US,
  DELETE_ADDRESS,
  GET_ALL_ORDER,
  GET_USER_PROFILE,
  PASSWORD_RECOVERY,
  PAYMENT_CART,
  PRODUCT_DETAILS,
  PRODUCT_FILTER,
  REMOVE_ITEM_ORDER,
  UPDATE_PROFILE,
  USER_ADDRESS,
  ZARINPAL_CREATE_LINK,
  ZARINPAL_VERIFICATION,
} from "../utility/BaseUrl";
import {
  getAddressIdFromCookie,
  getFullNameFromCookie,
  getPhoneFromCookie,
  getTokenFromCookie,
  getUserIdFromCookie,
  isTokenValid,
} from "../utility/Cookies";
import Request from "./Request";
const qs = require("qs");

export const LoadMainScreenService = async () => {
  const result = await Request(
    isTokenValid() ? { Authorization: "Bearer " + getTokenFromCookie() } : {},
    "get",
    ""
  );
  if (result.status === 0) {
    return;
  } else if (result.status === 200) {
    return result.result;
  } else {
    return result.result;
  }
};

export const ProductDetailsBySlugService = async (slug) => {
  const result = await Request(
    {
      Accept: "application/json",
    },
    "get",
    PRODUCT_DETAILS + slug
  );

  if (result.status === 0) {
    console.log(result.error);
    return;
  } else if (result.status === 200) {
    return result.result;
  } else {
    return result.result;
  }
};

export const AddToCartService = async (product_id, qty) => {
  let data = qs.stringify({
    product_id: product_id,
    qty: qty,
  });
  const result = await Request(
    {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      Authorization: "Bearer " + getTokenFromCookie(),
    },
    "post",
    ADD_TO_CART,
    data
  );

  return result;
};

export const RegisterService = async (
  family,
  name,
  password,
  password2,
  user_phone
) => {
  let data = qs.stringify({
    user_phone: user_phone,
    password2: password2,
    password: password,
    name: name,
    family: family,
  });
  const result = await Request(
    {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
    "post",
    ACCOUNT_REGISTER,
    data
  );
  return result;
};

export const ActiveCodeService = async (active_code, user_phone) => {
  let data = qs.stringify({
    active_code: active_code,
    user_phone: user_phone,
  });
  const result = await Request(
    {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
    "post",
    ACCOUNT_ACTIVE,
    data
  );
  return result;
};

export const LoginService = async (password, user_phone) => {
  let data = qs.stringify({
    password: password,
    user_phone: user_phone,
  });
  const result = await Request(
    {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
    "post",
    ACCOUNT_LOGIN,
    data
  );
  return result;
};

export const AddCommentService = async (comment, productId, rate) => {
  let data = qs.stringify({
    comment: comment, //"<string>"
    product: productId, //"<integer>"
    rate: rate, //"<long>"
  });
  const result = await Request(
    {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      Authorization: "Bearer " + getTokenFromCookie(),
    },
    "post",
    ADD_COMMENT,
    data
  );
  return result;
};

export const GetProfileService = async () => {
  const result = await Request(
    {
      Accept: "application/json",
      Authorization: "Bearer " + getTokenFromCookie(),
    },
    "get",
    GET_USER_PROFILE,
    null
  );

  return result;
};

export const RemoveItemOrderService = async (cardId) => {
  const result = await Request(
    {
      Accept: "application/json",
      Authorization: "Bearer " + getTokenFromCookie(),
    },
    "delete",
    REMOVE_ITEM_ORDER + cardId,
    null
  );

  return result;
};

export const UpdateProfileService = async (family, name, image) => {
  const formData = new FormData();
  formData.append("family", family);
  formData.append("name", name);
  if (image) formData.append("image", image);

  const headers = {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "put", UPDATE_PROFILE, formData);
  return result;
};

export const AddAddressService = async (address, city, state, postal_code) => {
  let data = qs.stringify({
    address: address,
    city: city,
    postal_code: postal_code,
    state: state,
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "post", ADD_NEW_ADDRESS, data);
  return result;
};

export const RequestPaymentCartService = async (addressId) => {
  let data = qs.stringify({
    address_id: addressId ?? getAddressIdFromCookie(),
    call_back: CALLBACK_PAYMENT,
    phone: getPhoneFromCookie(),
  });
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "post", ZARINPAL_CREATE_LINK, data);
  return result;
};

export const FilterProductService = async (
  category,
  color,
  product_name,
  price_max,
  price_min
) => {
  const headers = {
    Accept: "application/json",
  };

  const result = await Request(
    headers,
    "get",
    // `${PRODUCT_FILTER}?category=${category}&color=${color}&long_description=${product_name}&price_max=${price_max}&price_min=${price_min}&product_name=${product_name}&short_description=${product_name}`,
    `${PRODUCT_FILTER}?category=${category}&color=${color}&price_max=${price_max}&price_min=${price_min}&product_name=${product_name}`,
    null
  );
  return result;
};

export const PasswordRecoveryService = async (user_phone) => {
  let data = qs.stringify({
    user_phone: user_phone,
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  };

  const result = await Request(headers, "post", PASSWORD_RECOVERY, data);
  return result;
};

export const PasswordRecovery2Service = async (
  user_phone,
  active_code,
  password,
  password2
) => {
  let data = qs.stringify({
    user_phone: user_phone,
    active_code: active_code,
    password: password,
    password2: password2,
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  };

  const result = await Request(headers, "put", PASSWORD_RECOVERY, data);
  return result;
};

export const VerifyRequestPaymentCartService = async (amount, authority) => {
  let data = qs.stringify({
    amount: amount,
    authority: authority,
  });
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "post", ZARINPAL_VERIFICATION, data);
  return result;
};

export const FetchOrdersService = async () => {
  const headers = {
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "get", GET_ALL_ORDER, null);
  return result;
};

export const PaymentCartService = async (redId, user) => {
  // let data = qs.stringify({
  //   user: user.id,
  //   ref_id: `${redId}`,
  //   address: "",
  //   received_phone: `${getPhoneFromCookie()}`,
  //   received_full_name: `${getFullNameFromCookie()}`,
  //   default_address: getAddressIdFromCookie(),
  // });
  let data = {
    user: user.id,
    ref_id: `${redId}`,
    address: "",
    received_phone: `${getPhoneFromCookie()}`,
    received_full_name: `${getFullNameFromCookie()}`,
    default_address: getAddressIdFromCookie(),
  };

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };

  const result = await Request(headers, "post", PAYMENT_CART, data);
  return result;
};

export const ContactUsService = async (title, text) => {
  let data = qs.stringify({
    title: title,
    text: text,
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };
  const result = await Request(headers, "post", CONTACT_US, data);
  return result;
};

export const GetAllAddressService = async () => {
  const headers = {
    Accept: "application/json",
    Authorization: "Bearer " + getTokenFromCookie(),
  };
  const result = await Request(headers, "get", USER_ADDRESS, null);
  return result;
};

export const DeleteAddressService = async (addressId) => {
  const result = await Request(
    {
      Accept: "application/json",
      Authorization: "Bearer " + getTokenFromCookie(),
    },
    "delete",
    DELETE_ADDRESS + addressId,
    null
  );

  return result;
};
